import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constant";
import { showToast } from "./toastAction";
import { showLoaderAction, hideLoaderAction } from "./loaderAction";

const getIngredients = (setLoading) => async (dispatch) => {
  if (setLoading) {
    setLoading(true);
  }
  const res = await api("get", Constants.END_POINT.INGREDIENTS);
  if (res.success) {
    if (res.data) {
      dispatch({
        type: types.CHANGE_INGREDIENTS,
        payload: res.data,
      });
    }
  }
  if (setLoading) {
    setLoading(false);
  }
};
const addIngredients = (data, setLoading, history) => async (dispatch) => {
  setLoading(true);

  const res = await api("post", Constants.END_POINT.INGREDIENTS, data);
  if (res.success) {
    dispatch(getIngredients());
    history.goBack();
    dispatch(showToast({ severity: "success", summary: res.message }));
  }
  setLoading(false);
};
const editIngredient = (id, data, setLoading, history) => async (dispatch) => {
  setLoading(true);

  const res = await api("put", Constants.END_POINT.INGREDIENTS + id, data);
  if (res.success) {
    dispatch(getIngredients());
    history.goBack();
    dispatch(showToast({ severity: "success", summary: res.message }));
  }
  setLoading(false);
};

const IngredientsEnableDisableAction = (id, active) => async (dispatch) => {
  const payload = { isActive: active };
  const res = await api("put", Constants.END_POINT.INGREDIENTS + id, payload);
  if (res.success) {
    dispatch(getIngredients());
    dispatch(showToast({ severity: "success", summary: res.message }));
  } else {
    dispatch(showToast({ severity: "error", summary: res.message }));
  }
};

const getIngredient = (id, returnData) => async (dispatch) => {
  dispatch(showLoaderAction());
  const res = await api("get", Constants.END_POINT.INGREDIENTS + id);
  if (res.success) {
    dispatch(hideLoaderAction());
    if (res.data) {
      if (returnData) {
        returnData(res.data);
      }
    }
  }
  dispatch(hideLoaderAction());
};
const deleteIngredient = (id) => async (dispatch) => {
  const res = await api("delete", Constants.END_POINT.INGREDIENTS + id);
  if (res.success) {
    dispatch(getIngredients());
    dispatch(showToast({ severity: "success", summary: res.message }));
  } else {
    dispatch(showToast({ severity: "error", summary: res.message }));
  }
};
export {
  getIngredients,
  addIngredients,
  IngredientsEnableDisableAction,
  getIngredient,
  editIngredient,
  deleteIngredient,
};
